'use strict'
const AnimatedBgdText = {
    init: function() {
        document.addEventListener("scroll", function () {
            document.querySelectorAll(".jsBgdAnimated").forEach((item) => {
                let parent = item.closest(".f-animatedBgdText");
                let rect = parent.getBoundingClientRect();
                let windowHeight = window.innerHeight;

                let scrollProgress = Math.max(0, Math.min(1, (windowHeight - rect.top) / (windowHeight + rect.height)));

                let bgPosition = scrollProgress * 100;
                item.style.backgroundPosition = `center ${bgPosition}%`;
            });
        });
    },
}

export default AnimatedBgdText;

